// removed by extract-text-webpack-plugin
module.exports = {"add_icon":"CentricUI__widgets__DragEventPlaceholders__add_icon","success_icon":"CentricUI__widgets__DragEventPlaceholders__success_icon","dropIndicator":"CentricUI__widgets__DragEventPlaceholders__dropIndicator","successIndicator":"CentricUI__widgets__DragEventPlaceholders__successIndicator","loadingIndicator":"CentricUI__widgets__DragEventPlaceholders__loadingIndicator"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/ui/widgets/DragEventPlaceholders.css
// module id = 707
// module chunks = 10